import React from 'react';

export const Logo: React.FC<{ className?: string }> = ({ className = "w-12 h-12" }) => {
  return (
    <svg viewBox="0 0 512 512" className={className} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="bgGradient" x1="0%" y1="0%" x2="0%" y2="100%">
           <stop offset="0%" stopColor="#fafaf9" /> {/* stone-50 */}
           <stop offset="100%" stopColor="#e7e5e4" /> {/* stone-200 */}
        </linearGradient>
        <linearGradient id="primaryGradient" x1="0%" y1="0%" x2="100%" y2="100%">
           <stop offset="0%" stopColor="#5eead4" /> {/* teal-300 */}
           <stop offset="100%" stopColor="#2dd4bf" /> {/* teal-400 */}
        </linearGradient>
        <filter id="softShadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="4" stdDeviation="8" floodColor="#000" floodOpacity="0.1" />
        </filter>
      </defs>
      
      {/* Background Container */}
      <rect x="0" y="0" width="512" height="512" rx="128" fill="url(#bgGradient)" />
      
      {/* Icon Content - larger C to fill more space */}
      <g filter="url(#softShadow)" transform="translate(256, 256) scale(0.92) translate(-256, -256)">
        {/* The C shape - solid black like CoExpect text */}
        <path 
          d="M 370 140 A 150 150 0 1 0 370 372"
          fill="none"
          stroke="#1c1917"
          strokeWidth="52"
          strokeLinecap="round"
        />
        
        {/* The Baby (Lucide baby icon - outline only, brand green) */}
        {/* Scaled up to match larger C */}
        <g transform="translate(256, 256) scale(7.5) translate(-12, -12)">
          {/* Head/face outline with hair curl */}
          <path 
            d="M19.38 6.813A9 9 0 0 1 20.8 10.2a2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1"
            fill="none"
            stroke="#059669"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          {/* Left eye */}
          <circle cx="9" cy="12" r="0.5" fill="#059669" />
          {/* Right eye */}
          <circle cx="15" cy="12" r="0.5" fill="#059669" />
          {/* Smile */}
          <path 
            d="M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5"
            fill="none"
            stroke="#059669"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        
      </g>
    </svg>
  );
};
